import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ECircle extends OBase {
  update () {
    let centerTree = this.getVector3Input('center', false);
    let radiusTree = this.getFloatInput('radius');
    let segmentsTree = this.getFloatInput('segments');

    let output = this.outputs['circle'].paramObject;

    let dataTrees = [centerTree, radiusTree, segmentsTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let center = outDataTrees[0].branches[i][j];
        let radius = outDataTrees[1].branches[i][j];
        let segments = Number(outDataTrees[2].branches[i][j]);

        let paths = ECircle.createCircle(center, radius, segments);

        outTree.add(paths, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }

  static createCircle (center, radius, segments) {
    let paths = [];
    let path = [];
    const pi2 = Math.PI * 2.0;
    for (let t = 0; t < segments; t++) {
      let angle = t / segments * pi2;
      let p = center.clone().add((new THREE.Vector3(Math.cos(angle), Math.sin(angle), 0)).multiplyScalar(radius));
      // path.push(new ClipperLib.IntPoint(p.x, p.y))
      path.push(new ClipperLib.DoublePoint(p.x, p.y));
    }
    paths.push(path);

    return paths;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ECircle.js